import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  IGetListTripPayload,
  IListTripsSlice,
  ITrip,
  LIST_TRIPS_SLICE,
} from "./trips.constant";
import {
  onAddTrip,
  onGetListTrip,
  onUpdateStatusTrip,
  onUpdateTrip,
} from "./trips.thunk";
import dayjs from "dayjs";
export const today = dayjs();
const initialState: IListTripsSlice = {
  isGot: false,
  trips: [],
  dateFrom: today.toISOString(),
  status: null,
};
export const tripsSlice = createSlice({
  name: LIST_TRIPS_SLICE,
  initialState,
  reducers: {
    getListTrip: (state, action: PayloadAction<ITrip[]>) => {
      const data = action.payload;
      state.trips = data;
      state.isGot = true;
    },
    addTrip: (state, action: PayloadAction<ITrip>) => {
      const newUser = action.payload;
      state.trips.push(newUser);
    },
  },
  extraReducers: (builder) => {
    builder.addCase(
      onGetListTrip.fulfilled,
      (state, action: PayloadAction<IGetListTripPayload>) => {
        const data = action.payload;
        state.trips = data?.data;
        state.isGot = true;
        state.dateFrom = data?.dateFrom;
        state.status = data?.status;
      }
    );
    builder.addCase(onGetListTrip.rejected, (state) => {
      state.trips = [];
      state.isGot = false;
    });
    builder.addCase(onAddTrip.fulfilled, (state, action) => {
      state.trips.push(action.payload);
    });
    builder.addCase(onAddTrip.rejected, (state) => {
      console.error("❌ Thêm chuyến đi thất bại");
    });

    builder.addCase(onUpdateTrip.fulfilled, (state, action) => {
      const updated = action.payload;
      const index = state.trips.findIndex((c) => c._id === updated._id);
      if (index !== -1) state.trips[index] = updated;
    });
    builder.addCase(onUpdateStatusTrip.fulfilled, (state, action) => {
      const updated = action.payload;
      const index = state.trips.findIndex((c) => c._id === updated._id);
      if (index !== -1) state.trips[index] = updated;
    });
    builder.addCase(onUpdateTrip.rejected, (state) => {
      console.error("❌ Cập nhật chuyến đi thất bại");
    });
  },
});
export default tripsSlice.reducer;
